/* src/app/app.component.scss */
.app-shell {
  --sidebar-width: 300px;
  --sidebar-collapsed-width: 82px;
  --shell-background: #f7f8fb;
  --text-primary: #17213a;
  --overlay-background: rgba(15, 23, 42, 0.42);
  --transition-duration: 0.25s;
  position: relative;
  display: flex;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background:
    radial-gradient(
      circle at 90% 0%,
      rgba(99, 91, 255, 0.04),
      transparent 30%),
    var(--shell-background);
  overflow-x: clip;
}
.main-area {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: calc(100% - var(--sidebar-width));
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  margin-left: var(--sidebar-width);
  transition: width var(--transition-duration) ease, margin-left var(--transition-duration) ease;
}
.app-shell.sidebar-collapsed .main-area {
  width: calc(100% - var(--sidebar-collapsed-width));
  margin-left: var(--sidebar-collapsed-width);
}
.page-content {
  position: relative;
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0;
  padding: 15px;
  box-sizing: border-box;
  overflow-wrap: break-word;
}
.mobile-menu-button {
  display: none;
  position: fixed;
  top: 16px;
  left: 16px;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  z-index: var(--z-mobile-menu, 1200);
  border: 1px solid rgba(228, 231, 236, 0.9);
  border-radius: 12px;
  background: #fff;
  color: var(--text-primary);
  box-shadow: 0 8px 25px rgba(31, 45, 61, 0.14);
  font-size: 21px;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.mobile-menu-button:hover {
  box-shadow: 0 10px 28px rgba(31, 45, 61, 0.18);
}
.mobile-menu-button:active {
  transform: scale(0.95);
}
.mobile-menu-button:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.35);
  outline-offset: 3px;
}
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  z-index: var(--z-sidebar-overlay, 1200);
  padding: 0;
  border: 0;
  background: var(--overlay-background);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity var(--transition-duration) ease, visibility var(--transition-duration) ease;
}
@media (max-width: 991.98px) {
  .app-shell {
    display: block;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    overflow-x: clip;
  }
  .main-area,
  .app-shell.sidebar-collapsed .main-area {
    width: 100%;
    min-width: 0;
    min-height: 100vh;
    min-height: 100dvh;
    margin-left: 0;
  }
  .page-content {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 76px 16px 24px;
  }
  .mobile-menu-button {
    display: flex;
  }
  .sidebar-overlay {
    display: block;
  }
  .app-shell.mobile-sidebar-open .sidebar-overlay {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
  .app-shell.mobile-sidebar-open .mobile-menu-button {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .page-content {
    padding: 76px 20px 28px;
  }
}
@media (max-width: 767.98px) {
  .page-content {
    padding: 68px 10px 20px;
  }
}
@media (max-width: 575.98px) {
  .mobile-menu-button {
    top: 12px;
    left: 12px;
    width: 42px;
    height: 42px;
    border-radius: 11px;
    font-size: 20px;
  }
  .page-content {
    padding: 64px 8px 16px;
  }
}
@media (max-width: 375px) {
  .mobile-menu-button {
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    font-size: 19px;
  }
  .page-content {
    padding: 62px 6px 14px;
  }
}
@media (max-width: 991.98px) {
  .page-content > * {
    max-width: 100%;
    min-width: 0;
  }
  .page-content img,
  .page-content video,
  .page-content iframe {
    max-width: 100%;
  }
  .page-content img,
  .page-content video {
    height: auto;
  }
  .page-content table {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .page-content pre {
    max-width: 100%;
    overflow-x: auto;
  }
  .page-content {
    overflow-wrap: anywhere;
  }
}
@media (prefers-reduced-motion: reduce) {
  .main-area,
  .mobile-menu-button,
  .sidebar-overlay {
    transition: none !important;
  }
}
/*# sourceMappingURL=app.component.css.map */
